import React, { Component } from 'react';
import { Redirect, Link, withRouter } from 'react-router-dom';

import HolidayForm from '../../forms/Holidays';

import { hideElementForNonAdminsAndNonManagers } from '../../utilities/Forms.js'

import { faCheckCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import SlidingPane from "../../components/shared/ScrollableSlidingPane";
import { formatDate, holidaysDaysUsed } from "../../utilities/Generic"
import { request, handleRequestErrors } from '../../helpers/Requests'

class PersonHolidays extends Component {

  constructor(props) {
    super(props);

    this.handleUpdatePanel = this.handleUpdatePanel.bind(this);
    this.handleNewPanel = this.handleNewPanel.bind(this);
    this.closePanel = this.closePanel.bind(this);
  }

  state = {
    holidays: [],

    newPanelToggle: false,
    updatePanelToggle: false,
    holidayId: null,
    loaded: false,
    unauthorized: "",
    errors: "",
    error: ""
  };

  handleNewPanel(event) {
    this.setState({newPanelToggle: true});
  }

  handleUpdatePanel(event) {
    let id = event.currentTarget.id;

    this.setState({
      holidayId: id,
      updatePanelToggle: true
    });
  }

  closePanel() {
    this.setState({
      holidayId: null,
      newPanelToggle: false,
      updatePanelToggle: false
    });

    this.componentDidMount();
  }

  holidaysUsage() {
    const holidaysCount = holidaysDaysUsed(this.state.holidays)
    let allowedHolidays
    if (this.props.allowed_holidays === null || this.props.allowed_holidays === "" ) {
      allowedHolidays =  "?"
    }
    else {
      allowedHolidays = parseFloat(this.props.allowed_holidays)
    }
    // In JS, comparison of a number with "?" always returns false
    const red = holidaysCount > allowedHolidays ? "red-text" : ""

    return (
      <div className="inline-block">
        Usage: <span className={red}>{holidaysCount}</span>/{allowedHolidays} days have been booked this year.
      </div>
    )
  }

  emptyHolidays() {
    if (this.state.holidays.length === 0) {
      return (
        <div className="long-tr">
          <div className="long-td">
            There are no upcoming holidays for this year.
          </div>
        </div>
      )
    }
  }

  inThePast(time) {
    return new Date(time) < new Date();
  }

  render() {
    const { holidays, loaded, unauthorized, error } = this.state;

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return (
        <div>
          {error["errors"].map((errors, index) => (
            <div className="warning-box" key={index}>{errors}</div>
          ))}
        </div>
      )
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      let person_id = this.props.person_id;

      return (
        <div>
          <h3 className="inline-block margin-right">Holidays</h3>
          {this.holidaysUsage()}

          <Link to={`#`} onClick={this.handleNewPanel}>
            <div className={`button new-button ${hideElementForNonAdminsAndNonManagers()}`}>New Holiday</div>
          </Link>

          <div className="table big-table" data-testid="table">
            <div className="tr heading">
              <div className="th">Start Date</div>
              <div className="th">End Date</div>
              <div className="th">Taken?</div>
            </div>
            {holidays.map((holiday) => (
              <div onClick={this.handleUpdatePanel} id={holiday.id} key={holiday.id} className="tr holiday clickable">
                <div className="td">{formatDate(new Date(holiday.start_date), 0, "/", "dayFirst")} {holiday.half_day_work_at_start === true ? "(Half Day)" : ""}</div>
                <div className="td">{formatDate(new Date(holiday.end_date), 0, "/", "dayFirst")} {holiday.half_day_work_at_end === true ? "(Half Day)" : ""}</div>
                <div className="td center">{this.inThePast(holiday.end_date) ? <FontAwesomeIcon icon={faCheckCircle} /> : <FontAwesomeIcon icon={faTimes} />}</div>
              </div>
            ))}
          </div>
          {this.emptyHolidays()}

          <SlidingPane isOpen={this.state.newPanelToggle} title="New Holiday" width="50%"
            onRequestClose={() => { this.closePanel() }}>
            <HolidayForm mode="create" id={this.state.holidayId} person_id={person_id} closePanel={this.closePanel} />
          </SlidingPane>

          <SlidingPane isOpen={this.state.updatePanelToggle} title="Update Holiday" width="50%"
            onRequestClose={() => { this.closePanel() }}>
            <HolidayForm mode="update" id={this.state.holidayId} person_id={person_id} closePanel={this.closePanel} />
          </SlidingPane>
        </div>
      );
    }
  }

  componentDidMount() {
    let person_id = this.props.person_id;

    request("GET", `/v1/a/people/${person_id}/holidays`, "", () => {this.setState({unauthorized: true})})
      .then(data => this.setState({ holidays: data, loaded: true }))
      .catch(error => handleRequestErrors(this, error, { loaded: true }))
  }
}

export default withRouter(PersonHolidays);
